import StrategiesSuccess from './StrategiesSuccess';

export default StrategiesSuccess;
